import {Card, Form, Input, Button, Checkbox, Radio} from 'antd'
import {
  SearchOutlined,
  ReloadOutlined,
  DownloadOutlined, ImportOutlined,
} from '@ant-design/icons'
import React, {useEffect, useState} from 'react'
import { useLocation } from 'react-router'
import moment from 'moment'
import AuthComponent from '../../../../components/AuthComponent'
/**
 *
 * @param {String} name 表单名称
 * @param {Array} fields 表单项列表
 * @param {String} type 类型
 * @param {Object} initialValues  表单初始值（不可接收可变值）
 * @param {Object} defaultValue  表单默认值（接收可变值插入表单项）
 * @param {Function} onSearch 提交方法
 * @param {Function} onExport 导出方法
 * @param {Object} authKey 权限
 * @param children 可插入更多按钮
 * @returns 表单组件
 */
const BasicForm = (props) => {
  const { state } = useLocation()
  const {
    defaultValue = {},
    name,
    type,
    fields = [],
    onSearch = () => {},
    onExport = () => {},
    onUpload = () =>{},
    initialValues = {},
    authKey = { search: '', export: '',  batchImport: ''},
  } = props
  console.log('type=' + type);
  const [form] = Form.useForm()
  const [isDistribution, setIsDistribution] = useState([]);
  const onReset = () => {
    form.resetFields()
  }
  const handleExport = () => {
    onExport(form.getFieldValue())
  }
  // 批量导入
  const setBatchUpload = ()=>{
    onUpload();
  }
  const plainOptions = [
    { label: '供应商代发', value: 'MERCHANT' },
    { label: '门店发货', value: 'STORE' }
  ]
  const deliverTxt = ()=> (
    <div style={{width: '100%', marginBottom: '16px', display: 'flex'}}>
      <Form.Item label="配送方式" name="receiveWay" style={{width: '200px'}}>
        <Radio.Group>
          <Radio.Button value="快递配送">快递配送</Radio.Button>
        </Radio.Group>
      </Form.Item>
      {/* {type == '2'? <Form.Item label="发货方式" name="deliveryWays">
        <Checkbox.Group options={plainOptions} onChange={(val)=>{ setIsDistribution(val)}} />
      </Form.Item>: ''} */}
    </div>

  )
  //获取时间默认值
  useEffect(() => {
    if (state && state.createTime) {
      let createTime = [
        moment(state.createTime[0]),
        moment(state.createTime[1]).endOf('day'),
      ]
      form.setFieldsValue({ createTime })
    }
  }, [])
  useEffect(() => {
    form.setFieldsValue(defaultValue)
  }, [defaultValue])
  const onSearchHander = ()=>{
    onSearch({...form.getFieldsValue(), pageIndex: 1})
  }
  return (
    <Card style={{ marginBottom: '15px' }}>
      <Form
        name={name}
        layout="inline"
        form={form}
        initialValues={initialValues}
        style={{ marginBottom: '-10px' }}
      >
        {fields.map((item) => (
          <Form.Item
            label={item.label}
            name={item.name}
            key={item.name}
            style={{ marginBottom: '16px' }}
          >
            {item.component ? (
              item.component
            ) : (
              <Input
                allowClear
                style={{ width: item.width ? item.width : '200px' }}
                placeholder={item.placeholder || '请输入内容'}
              />
            )}
          </Form.Item>
        ))}
        {deliverTxt()}
      </Form>
      <div style={{marginTop: '10px'}}>
        <AuthComponent authKey={authKey.search}>
          <Button
            ghost
            style={{marginRight: '10px'}}
            type="primary"
            onClick={onSearchHander}
            icon={<SearchOutlined />}
          >
            查询
          </Button>
        </AuthComponent>
        <Button
          ghost
          style={{marginRight: '10px'}}
          type="primary"
          icon={<ReloadOutlined />}
          onClick={onReset}
        >
          重置
        </Button>
        <AuthComponent authKey={authKey.export}>
          <Button
            style={{marginRight: '10px'}}
            type="primary"
            icon={<DownloadOutlined />}
            onClick={handleExport}
          >
            导出
          </Button>
        </AuthComponent>
        {
          type  == '1'? <Button
            type="primary"
            style={{marginRight: '10px'}}
            onClick={()=>setBatchUpload()}
            icon={<ImportOutlined />}
          >
            批量导入</Button>: ''
        }
      </div>
    </Card>
  )
}
export default BasicForm
